module.exports = __webpack_public_path__ + "static/media/food_anchorage_1.a14d4362.svg";